export const appInfo = {
    name: 'Student Experience',
    namespace: 'n/a',
    version: '1.0.0',
    appVersion: '2.0.0',
};
